// extracted by mini-css-extract-plugin
export default {"content":"LearnDashboard_content__sD1xs","bg":"LearnDashboard_bg__GkGSL"};